import { render } from "./TramiteFormCargaAut.vue?vue&type=template&id=7842d33a&scoped=true"
import script from "./TramiteFormCargaAut.vue?vue&type=script&lang=js"
export * from "./TramiteFormCargaAut.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=7842d33a&scoped=true&lang=css"
import "./TramiteFormCargaAut.vue?vue&type=style&index=1&id=7842d33a&scoped=true&lang=css"
import "./TramiteFormCargaAut.vue?vue&type=style&index=2&id=7842d33a&scoped=true&lang=css"
import "./TramiteFormCargaAut.vue?vue&type=style&index=3&id=7842d33a&scoped=true&lang=css"
import "./TramiteFormCargaAut.vue?vue&type=style&index=4&id=7842d33a&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7842d33a"]])

export default __exports__